import React, { useState, useEffect } from "react";
import "./deathDashboard.css";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const ChecklistDashboard = (props) => {
  const CheckList = [
    {
      id: 1,
      Name: "Audio/Video Message",
      title: "audioVideoMessage",
    },
    {
      id: 2,
      Name: "Checklist",
      title: "checklist",
    },
    {
      id: 3,
      Name: "Personal Instruction",
      title: "personalInstructions",
    },
    {
      id: 4,
      Name: "Contact list",
      title: "contactList",
    },
    {
      id: 5,
      Name: "Important Documents",
      title: "importantDocument",
    },
    {
      id: 6,
      Name: "Email to Send",
      title: "emailsToSend",
    },
    {
      id: 11,
      Name: "List of Large Bills",
      title: "listOfLargeBills",
    },
    {
      id: 7,
      Name: "Litigation List",
      title: "litigationList",
    },
    {
      id: 8,
      Name: "Location of Personal items",
      title: "locationOfPersonalItems",
    },
    {
      id: 9,
      Name: "List Password",
      title: "listOfPasswords",
    },
    {
      id: 10,
      Name: "Funeral Wishes",
      title: "prepaidBurialExpenses",
    },
  ];
  const CheckListTrustee = [
    {
      id: 1,
      Name: "Audio/Video Message",
      title: "audioVideoMessage",
    },
    {
      id: 2,
      Name: "Checklist",
      title: "checklist",
    },
    {
      id: 3,
      Name: "Personal Instruction",
      title: "personalInstructions",
    },
    {
      id: 4,
      Name: "Contact list",
      title: "contactList",
    },
    {
      id: 5,
      Name: "Important Documents",
      title: "importantDocument",
    },
    {
      id: 6,
      Name: "Email to Send",
      title: "emailsToSend",
    },
    {
      id: 11,
      Name: "List of Large Bills",
      title: "listOfLargeBills",
    },
    {
      id: 7,
      Name: "Litigation List",
      title: "litigationList",
    },
    {
      id: 8,
      Name: "Location of Personal items",
      title: "locationOfPersonalItems",
    },
    {
      id: 9,
      Name: "List Password",
      title: "listOfPasswords",
    },
    {
      id: 10,
      Name: "Funeral Wishes",
      title: "prepaidBurialExpenses",
    },
  ];
  const [loading, setLoading] = useState(false);
  const [checklistform, setChecklistform] = useState({});
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const getCheckList = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchChecklist(ID);
      setLoading(false);

      if (data && data.data) {
        setChecklistform(data.data);
      } else {
        setChecklistform({
          audioVideoMessage: "Not Started",
          checklist: "Not Started",
          contactList: "Not Started",
          emailsToSend: "Not Started",
          importantDocument: "Not Started",
          personalInstructions: "Not Started",
          listOfLargeBills: "Not Started",
          litigationList: "Not Started",
          locationOfPersonalItems: "Not Started",
          listOfPasswords: "Not Started",
          prepaidBurialExpenses: "Not Started",
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    console.log("calling api checklist");
    if (props.role !== "trustee") {
      getCheckList();
    }
  }, []);
  return (
    <div>
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          CHECKLIST
          <ToolTipCreator name={"Death_Checklist"}/>
        </div>
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      {props.role !== "trustee" ? (
        <div style={{ height: "26rem", overflowY: "auto" }}>
          {props.role !== "protrustee"
            ? CheckList.map(
                (item, index) =>
                  checklistform[item.title] && (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #E8E9FF",
                        marginTop: "1rem",
                        marginBottom: "8px",
                        paddingBottom: "8px",
                      }}
                    >
                      <div className="checkListName">{item.Name}</div>
                      <div className="checklistStatus">
                        {checklistform[item.title]}
                      </div>
                    </div>
                  )
              )
            : CheckListTrustee.map(
                (item, index) =>
                  checklistform[item.title] && (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #E8E9FF",
                        marginTop: "1rem",
                        marginBottom: "8px",
                        paddingBottom: "8px",
                      }}
                    >
                      <div className="checkListName">{item.Name}</div>
                      <div className="checklistStatus">
                        {checklistform[item.title]}
                      </div>
                    </div>
                  )
              )}
        </div>
      ) : (
        <div
          style={{
            height: "26rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "700",
            fontFamily: "Poppins",
            fontSize: "14px",
            flexDirection: "column",
          }}
        >
          This information will be available to you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      )}
    </div>
  );
};
